module.exports = __webpack_public_path__ + "img/login-2.40add659.jpg";